import Pickleball_01 from 'assets/images/pictures/pickleball/pickleball_01.jpg';
import Pickleball_02 from 'assets/images/pictures/pickleball/pickleball_02.jpg';
import Pickleball_03 from 'assets/images/pictures/pickleball/pickleball_03.jpg';
import Pickleball_04 from 'assets/images/pictures/pickleball/pickleball_04.jpg';
import Pickleball_05 from 'assets/images/pictures/pickleball/pickleball_05.jpg';
import Pickleball_06 from 'assets/images/pictures/pickleball/pickleball_06.jpg';
import Pickleball_07 from 'assets/images/pictures/pickleball/pickleball_07.jpg';
import Pickleball_08 from 'assets/images/pictures/pickleball/pickleball_08.jpg';
import Pickleball_09 from 'assets/images/pictures/pickleball/pickleball_09.jpg';
import Pickleball_10 from 'assets/images/pictures/pickleball/pickleball_10.jpg';
import Pickleball_11 from 'assets/images/pictures/pickleball/pickleball_11.jpg';
import Pickleball_12 from 'assets/images/pictures/pickleball/pickleball_12.jpg';
import YoutubeEmbed from 'assets/videos/YoutubeEmbed';

const PickleballSlides = [
  //   {
  //     id: 0,
  //     component: (
  //       <YoutubeEmbed
  //         embedId='JgM_l3yPdK4?si=CqtxlzgdyFdM9EIG'
  //         title='活力秘技'
  //       />
  //     ),
  //   },
  {
    id: 1,
    component: (
      <img
        src={Pickleball_01}
        style={{ maxWidth: '100%', height: 'auto' }}
        alt='Pickleball 01'
      />
    ),
  },
  {
    id: 2,
    component: (
      <img
        src={Pickleball_02}
        style={{ maxWidth: '100%', height: 'auto' }}
        alt='Pickleball 02'
      />
    ),
  },
  {
    id: 3,
    component: (
      <img
        src={Pickleball_03}
        style={{ maxWidth: '100%', height: 'auto' }}
        alt='Pickleball 03'
      />
    ),
  },
  {
    id: 4,
    component: (
      <img
        src={Pickleball_04}
        style={{ maxWidth: '100%', height: 'auto' }}
        alt='Pickleball 04'
      />
    ),
  },
  {
    id: 5,
    component: (
      <img
        src={Pickleball_05}
        style={{ maxWidth: '100%', height: 'auto' }}
        alt='Pickleball 05'
      />
    ),
  },
  {
    id: 6,
    component: (
      <img
        src={Pickleball_06}
        style={{ maxWidth: '100%', height: 'auto' }}
        alt='Pickleball 06'
      />
    ),
  },
  {
    id: 7,
    component: (
      <img
        src={Pickleball_07}
        style={{ maxWidth: '100%', height: 'auto' }}
        alt='Pickleball 07'
      />
    ),
  },
  {
    id: 8,
    component: (
      <img
        src={Pickleball_08}
        style={{ maxWidth: '100%', height: 'auto' }}
        alt='Pickleball 08'
      />
    ),
  },
  {
    id: 9,
    component: (
      <img
        src={Pickleball_09}
        style={{ maxWidth: '100%', height: 'auto' }}
        alt='Pickleball 09'
      />
    ),
  },
  {
    id: 10,
    component: (
      <img
        src={Pickleball_10}
        style={{ maxWidth: '100%', height: 'auto' }}
        alt='Pickleball 10'
      />
    ),
  },
  {
    id: 11,
    component: (
      <img
        src={Pickleball_11}
        style={{ maxWidth: '100%', height: 'auto' }}
        alt='Pickleball 11'
      />
    ),
  },
  {
    id: 12,
    component: (
      <img
        src={Pickleball_12}
        style={{ maxWidth: '100%', height: 'auto' }}
        alt='Pickleball 12'
      />
    ),
  },
];

export default PickleballSlides;
